import { Component, OnInit, ViewChild } from '@angular/core';
import { ElectService } from '../../service/elect.service';
import { Router, NavigationExtras } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-votes',
  templateUrl: './votes.component.html',
  styleUrls: ['./votes.component.css']
})
export class VotesComponent implements OnInit {
 theVotes;
 one;
 two;
 three;
 four;
 five;
 six;
 seven;
 eight;
 nine;
 ten;
 eleven;
 twelve;
 thirteen;
 fourteen;

 allvo;

 public barChartOptions = {
   scaleShowVerticleLines: false,
   responsive: true,
 };
 public barChartLabels = [
 'Vanlalliana', 
 'Jerome K Lalrosanga', 
 'R Rodinmawia', 
 'Lalrengliana', 
 'Richard B Lalhriatpuia',
 'J Lalrimawia', 
 'Benjamin Lalremruata', 
 'R Lalnunsanga (Nuntea)', 
 'Lalthansanga Fanai', 
 'R Lalrinmawia',
 'Lalramthara Pautu',
 'Anthony Vanlalhruaia',
 'Zairemtluanga Ralte',
 'Lalremruata' 
 ];
 public barChartType = 'bar';
 public barChartLegend = true;
 public barChartData = [];

  constructor(
  	private elsrv: ElectService,   
              public router: Router,
              private route: ActivatedRoute,
              private afa: AngularFireAuth

  	) { 

  }

  ngOnInit(): void {
  	 this.elsrv.getAllVotes().subscribe(async vc => {
  	 	this.theVotes = await vc;
  		this.p();
  	});
     this.elsrv.gettheVotes().subscribe(vt => {
       console.log(vt.length);
     });
	}

	p(){
		let onecounter = 0;
		let twocounter = 0;
		let threecounter = 0;
		let fourcounter = 0;
		let fivecounter = 0;
		let sixcounter = 0;
		let sevencounter = 0;
		let eightcounter = 0;
		let ninecounter = 0;
		let tencounter = 0;
		let elevencounter = 0;
		let twelvecounter = 0;
		let thirteencounter = 0;
    let fourteencounter = 0;
    let fifteencounter = 0;
		for (const obj of this.theVotes) {
	  		if (obj.vote === 'Vanlalliana') onecounter++;
	  		if (obj.vote === 'Jerome K Lalrosanga') twocounter++;
	  		if (obj.vote === 'R Rodinmawia') threecounter++;
	  		if (obj.vote === 'Lalrengliana') fourcounter++;
	  		if (obj.vote === 'Richard B Lalhriatpuia') fivecounter++;
	  		if (obj.vote === 'J Lalrimawia') sixcounter++;
	  		if (obj.vote === 'Benjamin Lalremruata') sevencounter++;
        if (obj.vote === 'R Lalnunsanga (Nuntea)') eightcounter++;
        if (obj.vote === 'Lalthansanga Fanai') ninecounter++;
        if (obj.vote === 'R Lalrinmawia') tencounter++;
        if (obj.vote === 'Lalramthara Pautu') elevencounter++;
        if (obj.vote === 'Anthony Vanlalhruaia') twelvecounter++;
        if (obj.vote === 'Zairemtluanga Ralte') thirteencounter++;
        if (obj.vote === 'Lalremruata') fourteencounter++;
		}
    this.barChartData = [
      {
         data: [onecounter, twocounter, threecounter, fourcounter, fivecounter, sixcounter, sevencounter, eightcounter, ninecounter, tencounter, elevencounter,twelvecounter,thirteencounter, fourteencounter], 
         label: 'Vote'
       }
     ]

		this.one= onecounter;
    this.two = twocounter;
		this.three = threecounter;
		this.four = fourcounter;
		this.five = fivecounter;
		this.six = sixcounter;
    this.seven = sevencounter;
    this.eight = eightcounter;
    this.nine = ninecounter;
    this.ten = tencounter;
    this.eleven = elevencounter;
    this.twelve = twelvecounter;
    this.thirteen = thirteencounter;
    this.fourteen = fourteencounter;
	}

}
